<template>
  <div>
    <GDQQuestionnaire v-if="formerror === 0" api="1" :successurl="successurl" />
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import GDQQuestionnaire from './GDQQuestionnaire.vue'

const route = useRoute()
const store = useStore()

const token = ref(route.params.t ? route.params.t : '')
const survey_id = ref(route.params.i ? route.params.i : '')
const successurl = ref(route.query.u ? route.query.u : '')
const formerror = ref(1)

const surveymember_get = () => {
  const filter = {
    groupsurveymember_token: {
      operator: '=',
      value: token.value
    },
    survey_id: {
      operator: '=',
      value: survey_id.value
    }
  }
  store
    .dispatch('questionnaire_gdqsurveymember_fetch', { filter })
    .then(resp => {
      if (resp.data.total !== 1) {
        formerror.value = 1
      } else {
        formerror.value = 0
      }
    })
}

onMounted(() => {
  surveymember_get()
})
</script>
<style scoped></style>
